import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {Response, StaticMethods} from '../../../model/GeneralModels';
import {CompanyOffer, HealthOffer} from '../../../model/SamanHealthFamilyModels';
import {AppSettingsService} from '../../../services/app-settings.service';
import {AuthService} from '../../../services/auth.service';
import {FormBuilder, Validators} from '@angular/forms';


@Component({
  selector: 'app-offer-select',
  templateUrl: './offer-select.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/css/light.theme.css'
  ],
  styles: [`
    .main .offer .offers .info .row .col {
      white-space: normal;
    }
  `]
})
export class OfferSelectComponent implements OnInit {
  healthOffers: any[];
  requestID: number;
  companyNames: string[] = [];
  translatedHealthOffers: HealthOffer[] = [];
  companyOffer: CompanyOffer;
  formGroup = this.fb.group({
    companyName: ['', Validators.required],
    offerID: ['', Validators.required]
  });
  translation: any = {};
  constructor(private router: Router,
              private service: HealthInsuranceService,
              public settings: AppSettingsService,
              private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, 'requestID', '/HEALTH/requests')) {
      this.healthOffers = history.state.healthOffers;
      console.log(this.healthOffers);
      this.requestID = history.state.requestID;
      if (!this.healthOffers) {
        this.service.getHealthOffers(this.requestID).subscribe((response: Response) => {
          if (response.success) {
            this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
            console.log(this.requestID, response);
            this.generateList(response.data, this.translation);
          } else {
            StaticMethods.showError(response.message);
          }
        });
      } else {
        this.generateList(this.healthOffers, history.state.translation);
      }
    }
  }

  onSelectionChange(offerID: number) {
    if (!this.formGroup.controls.offerID.value) {
      this.formGroup.controls.offerID.patchValue(offerID);
    }
    let element = document.getElementById(this.formGroup.controls.offerID.value + '');
    if (element) {
      element.style.display = 'none';
    }
    element = document.getElementById(offerID + '');
    element.style.display = 'block';
    this.formGroup.controls.offerID.patchValue(offerID);
  }

  generateList(healthOffers: any[], translation: any) {
    this.companyNames = [];
    healthOffers.forEach(offer => {
      console.log(offer);
      const index = this.translatedHealthOffers.length;
      console.log(translation);
      this.translatedHealthOffers[index] = new HealthOffer(offer, this.settings, translation);
    });
    console.log(this.translatedHealthOffers);
    this.companyOffer = new CompanyOffer(this.translatedHealthOffers);
    for (const key in this.companyOffer.companies) {
      if (this.companyOffer.companies.hasOwnProperty(key)) {
        this.companyNames[this.companyNames.length] = key;
      }
    }
    console.log(this.companyNames);
    this.formGroup.controls.companyName.patchValue(this.companyNames[0]);
  }

  submit() {
    if (this.authService.decode() && this.authService.decode().Role === 'user') {
      this.service.selectHealthOffer(this.requestID, this.formGroup.controls.offerID.value)
        .subscribe((response: Response) => {
          if (response.success) {
            this.router.navigate(['/health/family/details'], {
              state: {
                requestID: this.requestID
              }
            });
          }
        });
    } else {
      this.router.navigate(['login'],
        {queryParams: {returnUrl: '/health/family/health-offer'}, state: history.state}
      );
    }
  }
}
